import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification, NotificationState } from "../types/notification.type";

const initialState: NotificationState = {
  notifications: [],
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<INotification[]>) => {
      state.notifications = action.payload;
    },
    addNotification: (state, action: PayloadAction<INotification>) => {
      // Chống trùng ngay tại reducer để nơi gọi không phải đọc `notifications`
      // — đọc ở component sẽ kéo state vào deps của effect và làm luồng SSE
      // ngắt/mở lại sau mỗi thông báo.
      const isExisted = state.notifications.some(
        (notification) => notification.id === action.payload.id
      );

      if (isExisted) {
        return;
      }

      state.notifications.unshift(action.payload);
    },
  },
});

export const notificationAction = notificationSlice.actions;

export const notificationReducer = notificationSlice.reducer;
